<template>
  <div class="bg-white rounded-xl shadow p-6">
    <h1 class="text-2xl font-semibold text-neutral-800 mb-2">Solicitudes</h1>
    <p class="text-neutral-500">Sección en construcción con datos mock.</p>
  </div>
</template>

<script>
export default {
  name: "TeacherRequests",
};
</script>
